export function computePetPower(card, stats) {
  if (!card) return 0;

  return Math.floor(
    (card.basePower || 0) +
      (stats.visits || 0) * 3 +
      (stats.clicks || 0) * 1 +
      (stats.scrolls || 0) * 2 +
      (stats.drags || 0) * 4 +
      Math.floor((stats.timeMs || 0) / 60000) * 5 +
      (stats.powerups || 0) * 25
  );
}
